"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonPager_de_de = void 0;
function commonPager_de_de() {
    return {
        "pager.back": "zurück",
        "pager.next": "weiter",
        "pager.more": "mehr",
        "pager.itemsperpagelabel": "Elemente pro Seite",
        "pager.firstpagelabel": "Erste Seite",
        "pager.nextpagelabel": "Nächste Seite",
        "pager.previouspagelabel": "Vorherige Seite",
        "pager.lastpagelabel": "Letzte Seite",
        "pager.of": "von"
    };
}
exports.commonPager_de_de = commonPager_de_de;
